import { EffectComposer, Bloom } from '@react-three/postprocessing'
import { isMobile } from 'react-device-detect'
const BLOOM = {
  intensity: isMobile ? 0.12 : 0.07,  
  threshold: 1.00,
  radius: 0.7,
  levels: isMobile ? 7 : 9,  
}
export default function Effects() {
  return (
    <EffectComposer disableNormalPass multisampling={isMobile ? 2 : 4}>
      <Bloom
        mipmapBlur
        luminanceThreshold={BLOOM.threshold}
        intensity={BLOOM.intensity}
        radius={BLOOM.radius}
        levels={BLOOM.levels}
      />
    </EffectComposer>
  )
}